<template>
<div>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            offset-sm0
            md10
            offset-md0
            lg9
            offset-lg1
            xl7
            offset-xl1
            pt-3
            pr-3
          >
           <ListingSuchbegriff
              v-if="this.$store.state.route.path == '/handwerker' && $store.state.suche.betriebe.length > 0"
            ></ListingSuchbegriff>
            <!-- <div v-if="this.$store.getters.fetchSuchbegriff.gewerk">
              <div v-if="this.$store.getters.fetchSuchbegriff.gewerk.wizard != null">
                <v-btn @click="OpenWizard()" class="mt-3"> <v-icon left>call_split</v-icon> Vermittlungsfunktion verfügbar </v-btn>
              </div>
            </div> -->
            <span class="hidden-xs-only">
             <!-- <h3 class="title mt-5 mb-3">Ansicht</h3> -->
            <v-btn-toggle v-model="ansicht" class="mt-4" mandatory>
              <v-btn flat large value="card" class="px-3">
                <v-icon>grid_view</v-icon>
              </v-btn>
              <v-btn flat large value="liste" class="px-3">
                <v-icon>reorder</v-icon>
              </v-btn>
            </v-btn-toggle>
            </span>
          </v-flex>
           <v-flex
            xs12
            sm12
            offset-sm0
            md2
            offset-md0
            lg2
            offset-lg0
            xl2
            offset-xl1 
            class="pt-4 "
          >
          <h3 class="title">Sortierung</h3>
          <v-radio-group v-model="sort">
              <v-radio
                key="n1"
                label="Lokale Handwerker"
                value="beste"
              ></v-radio>
               <v-radio
                key="n2"
                label="Alphabetisch"
                value="name"
              ></v-radio>
              <v-radio
                key="n3"
                disabled
                label="Verfügbarkeit"
                value="verfuegbarkeit"
              ></v-radio>
               <v-radio
                key="n4"
                :disabled="standortdisabled"
                label="Entfernung"
                value="entfernung"
              ></v-radio>
            </v-radio-group>
            <v-layout row v-if="standortdisabled">
              <v-flex> 
                <v-btn flat class="my-0" @click="geolocation()"  :loading="geolocatebusy">
                  Standort finden
                </v-btn>
              </v-flex>
              <v-flex>
                <v-btn
                @click="showgeoinfo =! showgeoinfo" 
                class="mt-0" icon>
                  <v-icon>help_outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <div v-if="showgeoinfo && standortdisabled">Die Berechnung der Entfernung findet auf Ihrem Gerät statt, es werden <strong>keine</strong> Daten zu Ihrem Standort an LokalesHandwerk gesendet. <a href="https://support.mozilla.org/de/kb/gibt-firefox-meinen-standort-websites-frei#w_standortbezogenes-surfen-geolokalisierung" target="_blank">Mehr Informationen..</a></div>
           </v-flex>
        </v-layout>
      </v-container>
        <div v-if="this.$store.getters.fetchBetriebe.betriebe">
          <span v-if="ansicht === 'card'">
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex lg12 offset-lg0 xl10 offset-xl1>
               <v-layout row wrap fill-height>
                <v-flex 
                  xs12 
                  sm6 
                  md4 
                  lg3
                  grow
                  v-for="betrieb in sortierteBetriebeEntfernung" 
                  :key="betrieb.id"
                >
                  <landing-betrieb :betrieb="betrieb"></landing-betrieb>
                </v-flex>
              </v-layout>
             </v-flex>
            </v-layout>        
          </v-container>
          </span>
          <span v-if="ansicht === 'liste'">
            <v-container>
              <v-layout>
                <v-flex lg12 offset-lg0 xl8 offset-xl2>
                  <v-list three-line class="elevation-2">
                  <landing-betrieb-liste 
                    :betrieb="betrieb" 
                    v-for="(betrieb, index) in sortierteBetriebeEntfernung" 
                    :key="betrieb.id"
                    :index="index"
                  ></landing-betrieb-liste>
                  </v-list>
              </v-flex>
              </v-layout>        
            </v-container>
          </span>
          <v-container 
            class="text-xs-center mb-3" 
            v-if="limit < locationsWithDistance.length"
          >
           <span class="subheading">
             Zeige <strong>{{ limit }}</strong> von 
             <strong>{{ locationsWithDistance.length }}</strong>
           </span> 
            <br>
            <v-btn
              large
              class="accent"
              @click="limit = limit + 12"
            >
              Mehr anzeigen
            </v-btn>
          </v-container>
          <v-container 
            class="text-xs-center mb-3" 
            v-if="limit >= locationsWithDistance.length"
          >
            <v-btn
              large
              class="accent"
              :to="this.Zurueck"
            >Zurück zum Start </v-btn>
          </v-container>
        </div>
        
<div v-if="this.$store.getters.fetchSuchbegriff.gewerk">
  <div v-if="this.$store.getters.fetchSuchbegriff.gewerk.wizard != null">
    <anfragen-modal 
      :stadt="this.$store.getters.fetchBetriebe.standortwert[0].name" 
      :leistung="this.$store.getters.fetchSuchbegriff" 
      :key="this.$store.getters.fetchSuchbegriff.id" 
      ref="modal">
    </anfragen-modal>
  </div>
</div>
<div v-if="this.$store.getters.fetchBetriebe.kh">
  <div v-if="this.$store.getters.fetchBetriebe.kh.skyline">
    <bottom-banner v-if="this.$store.getters.fetchBetriebe.kh.skyline" :skyline="this.$store.getters.fetchBetriebe.kh.skyline" :slug="this.$store.getters.fetchBetriebe.kh.slug"></bottom-banner>
    </div>
  </div>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
// import debounce from 'lodash/debounce'

import LandingBetrieb from '~/components/listing/ListingBetrieb.vue'
import LandingBetriebListe from '~/components/listing/ListingBetriebListe.vue'
import ListingSuchbegriff from '~/components/listing/ListingSuchbegriff.vue'
import AnfragenModal from '~/components/anfragen/AnfragenModalStart.vue'
import BottomBanner from '~/components/kreishandwerkerschaften/BottomBanner.vue'

export default {
  // metaInfo () {
  //   return {
  //     title: 'Lokale Handwerker'
  //   }
  // },
  components: {
   // StartseiteMap
   // AnfragenModalStart,
    LandingBetrieb,
    ListingSuchbegriff,
    LandingBetriebListe,
    AnfragenModal,
    BottomBanner
  },
  data: () => ({
    isLoading: false,
    busy: false,
    Stadt: null,
    search: null,
    loading: false,
    limit: 16,
    scroll: null,
    ansicht: 'card',
    toggle_one: 0,
    showgeoinfo: false,
    radioGroup: 1,
    geolocatebusy: false,
    geolocatedisabled: false,
    sort: 'beste',
    zeigekarte: false,
    currentLocation: { lat: '', lng: '', typ: '' }
  }),
  computed: {
    standortdisabled: function () {
      if (this.$store.getters.fetchStandort.typ > 1) return false
      else return true
    },
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'display-1'
      } else {
        return 'display-3'
      }
    },
    Zurueck: function () {
      if (this.$store.getters.fetchBetriebe.kh) {
        return '/kh/' + this.$store.getters.fetchBetriebe.kh.slug
      } else {
        return '/'
      }
    },
    Überschrift: function () {
      var text = this.$store.getters.fetchSuchbegriff.leistung
      if (this.$route.params.stadt) {
        if (this.data.stadt) {
          text = text + ' in ' + this.data.stadt.name
        } else {
          text =
            text +
            ' in ' +
            this.$route.params.stadt.charAt(0).toUpperCase() +
            this.$route.params.stadt.slice(1)
        }
      }
      return text
    },
    sortierteBetriebeEntfernung: function () {
      var sortierung = this.sort
      var richtungsort = ['asc']

      if (sortierung === 'beste') {
        sortierung = ['premium', 'verfuegbar', 'name']
        richtungsort = ['desc', 'desc', 'asc']
      }
      if (sortierung === 'verfuegbarkeit') {
        sortierung = ['verfuegbar', 'premium', 'name']
        richtungsort = ['desc', 'desc', 'asc']
      }
      const liste = orderBy(this.locationsWithDistance, sortierung, richtungsort)
      return this.limit ? liste.slice(0, this.limit) : this.liste
    },
    locationsWithDistance () {
     //
      if (this.$store.getters.fetchStandort.typ < 2) {
        return this.$store.getters.fetchBetriebe.betriebe
      } else {
        return this.$store.getters.fetchBetriebe.betriebe.map(l => {
          var ort = this.$store.getters.fetchStandort
          var p = 0.017453292519943295 // Math.PI / 180
          var c = Math.cos
          var a =
          0.5 -
          c((l.geo_lat - ort.lat) * p) / 2 +
          c(ort.lat * p) *
          c(l.geo_lat * p) *
          (1 - c((ort.lng - l.geo_lng) * p)) / 2
          var BetriebsEntfernung =
          Math.round(12742 * Math.asin(Math.sqrt(a)) * 100) / 100

          return {
            ...l,
            entfernung: BetriebsEntfernung
          }
        })
      }
    }
  },
  mounted: function () {
    this.CheckObVuexLeer()
  },
  beforeDestroy () {
   // window.removeEventListener('scroll', this.handleScroll);

  },
  deactivated () {
  },
  created () {

   // this.handleDebouncedScroll = debounce(this.handleScroll, 100)
   // window.addEventListener('scroll', this.handleDebouncedScroll)

    // this.neuGEOIP();
  },
  destroyed () {
   // window.removeEventListener('scroll', this.handleScroll);
  },
// 2do + vuex
  watch: {
    $route (to, from) {
      if (to.name === 'startseite' && from.name === 'handwerker') {
        this.limit = 16
      }
    }
  },
  methods: {
    // validate () {
    // 	this.$validator.validate();
    // },
    handleScroll (e) {
      // this.scroll = window.scrollY || window.scrollTop
     // console.log('scroll' + this.scroll)
     // console.log('scrollY: ' + window.scrollY + ' - offsetHeight: ' + window.offsetHeight)
    //  console.log('inner: ' + window.innerHeight)
    },

    CheckObVuexLeer: function () {
      if (this.$store.getters.fetchBetriebe.betriebe.length < 1) {
        this.$router.push({
          name: 'startseite'
        })
      }
    },
    loescheBetriebe () {
      this.$store.dispatch('loescheBetriebe')
      this.$router.push({
        name: 'startseite'
      })
    },
    OpenWizard () {
      this.$refs.modal.openmodalfunction()
      console.log('emmited..')
    },
    geolocation: function () {
      if (navigator.geolocation) {
        this.geolocatebusy = true
        navigator.geolocation.getCurrentPosition(position => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy
          }
          if (this.currentLocation.accuracy > 5000) {
            console.log('ungenau')
            console.log(this.currentLocation.accuracy)
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'Standort kann leider nur ungenau erkannt werden.'
            })
          } else if (this.currentLocation.accuracy < 5000 && this.currentLocation.accuracy > 2000) {
            const payload = {
              'lat': this.currentLocation.lat,
              'lng': this.currentLocation.lng,
              'accuracy': this.currentLocation.accuracy
            }
            this.$store.dispatch('neueGeolocatePosi', payload)
            this.sort = 'entfernung'
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'Standort nur ungenau erkannt.'
            })
          } else {
            const payload = {
              'lat': this.currentLocation.lat,
              'lng': this.currentLocation.lng,
              'accuracy': this.currentLocation.accuracy
            }
            this.$store.dispatch('neueGeolocatePosi', payload)
            this.sort = 'entfernung'
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Standort erkannt'
            })
          }
        },
        error => {
          this.$store.dispatch('responseMessage', {
            type: 'warning',
            text: 'Standorterkennung leider nicht verfügbar.'
          })
          console.log(error.message)
          this.geolocatebusy = false
        })
        this.geolocatebusy = false
      } else {
        console.log('geolocate false')
        this.$store.dispatch('responseMessage', {
          type: 'warning',
          text: 'Standorterkennung nicht verfügbar.'
        })
        this.geolocatebusy = false
      }
    },
    resetlocation: function () {
      var payload = {
        'lat': '',
        'lng': '',
        'accuracy': '',
        'typ': ''
      }
      this.$store.dispatch('GeolocateReset', payload)
    }
  }
}
</script>

<style >
</style>